import { render, staticRenderFns } from "./RestoreQuestionnaireModal.vue?vue&type=template&id=8761e2d4&scoped=true"
import script from "./RestoreQuestionnaireModal.vue?vue&type=script&lang=js"
export * from "./RestoreQuestionnaireModal.vue?vue&type=script&lang=js"
import style0 from "./RestoreQuestionnaireModal.vue?vue&type=style&index=0&id=8761e2d4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8761e2d4",
  null
  
)

export default component.exports